import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Loader } from 'oxyrion-ui/lib';
import { LoaderWrapper } from '../ReusableComponents';
import { __, formatNumber } from '../../Utils';
import { rem } from 'polished';
import C3Chart from 'react-c3js';
import 'c3/c3.css';
import { connect } from '../../Store';

const StyledChart = styled(C3Chart)``;

const Wrapper = styled.div`
  min-width: 600px;
  ${({ theme }) => theme.media.m`
  padding-right: ${rem(50)};
`};
`;

const Header = styled.div`
  font-family: 'Open Sans';
  font-weight: 100;
  font-size: ${rem(30)};
  margin-bottom: ${rem(22)};
`;

class OrdersGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: {
        columns: [
          ['data1', 3400, 9000, 11000, 2000, 21345, 0, 0, 0, 0, 0, 0, 0],
        ],
        type: 'bar',
        colors: {
          data1: '#6f6f6f',
        },
        names: {
          data1: __('Obrat, objednané'),
        },
      },
      axis: {
        x: {
          type: 'category',
          categories: [
            'JAN',
            'FEB',
            'MAR',
            'APR',
            'MAJ',
            'JUN',
            'JUL',
            'AUG',
            'SEP',
            'OKT',
            'NOV',
            'DEC',
          ],
        },
        y: {
          tick: {
            format: d => {
              return this.props.firm === 'SK'
                ? `${formatNumber(d, 2)} €`
                : `${formatNumber(d, 0)} Kč`;
            },
            //                format: function (d) { return "$" + d; }
          },
        },
      },
      grid: {
        x: {
          show: true,
        },
      },
      regions: [
        { start: -1, end: 0.5 },
        { start: 1.5, end: 2.5 },
        { start: 3.5, end: 4.5 },
        { start: 5.5, end: 6.5 },
        { start: 7.5, end: 8.5 },
        { start: 9.5, end: 10.5 },
      ],
    };
  }

  componentWillReceiveProps(props) {
    const { chartData } = this.state;
    chartData.columns = [['data1', ...props.data.orders]];
    this.setState({
      chartData,
    });
  }

  componentDidMount() {
    const { chartData } = this.state;
    chartData.columns = [['data1', ...this.props.data.orders]];

    this.setState({
      chartData,
    });
  }

  render() {
    const { header, loading } = this.props;

    if (loading)
      return (
        <LoaderWrapper style={{ width: '100%' }}>
          <Loader size="xl" />
        </LoaderWrapper>
      );

    return (
      <React.Fragment>
        {header && <Header>{header}</Header>}
        <Wrapper>
          <StyledChart
            // unloadBeforeLoad
            data={this.state.chartData}
            axis={this.state.axis}
            grid={this.state.grid}
            regions={this.state.regions}
          />
        </Wrapper>
      </React.Fragment>
    );
  }
}

OrdersGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  header: PropTypes.string,
  firm: PropTypes.string,
  loading: PropTypes.loading,
};

OrdersGraph.defaultProps = {
  header: undefined,
  data: {
    plan: [],
    actual: [],
  },
  firm: 'SK',
  loading: false,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(OrdersGraph);



// WEBPACK FOOTER //
// ./src/Components/OrdersGraph/index.jsx